//hook
import useWindowDimension from "../hook/use.window.dimension";

//component
import Footer from "../footer/footer";

import BottomNavBar from "../bar/bottom.bar";
import Header from "../header/header";

import { useEffect, useRef } from "react";
import scrollToTop from "../../helpers/scroll.to.top";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { closeFullLoading, getLanguage, getRole, getToken, getUserId, getUsername } from "../../redux/reducer/common.reducer";

import LoginModal from "../../pages/profile/modals/login.modal";
import GalleryModal from "../../pages/home/modals/gallery.modal";
import FullSizeGallery from "../common/full.size.gallery";
import Preloader from "../../pages/preloader";
import i18n from "i18next";
import ReportModal from "../../pages/home/modals/report.modal";

export default function MainLayout(props) {
  const dispatch = useDispatch();
  const mobileRef = useRef(null);
  const siteRef = useRef(null);
  const { width, isDesktop } = useWindowDimension();
  const { className } = props;
  const { pathname, hash, key } = useLocation();
  const {
  isOpenLoginModal,
  isOpenGalleryModal,
  isOpenReportModal
} = useSelector((state) => state.modal);
  const {
  token,
  language,
  isOpenFullSizeGallery
} = useSelector((state) => state.common);
  const isProductRoute = /^\/car(?:-plate)?\//.test(pathname);
  const isDesktopLayout = width >= 992 || (isProductRoute && width >= 768);
  const isPurchaseRoute =
    !isDesktop && (pathname === "/purchases" || pathname === "/consignments");
  const isFooterRoute = !isDesktop && [
    "/about-us", "/blog", "/careers", "/insurance", "/dealership-program",
    "/privacy-policy", "/terms-and-conditions", "/reservation-policy",
  ].includes(pathname.replace(/\/+$/, ""));

  useEffect(() => {
    i18n.changeLanguage(language);
    // Exposed on <html> so the stylesheet can relax the single-line labels for
    // languages whose copy is longer than the English original.
    document.documentElement.lang = language || "en";
    document.documentElement.dataset.lang = language || "en";
  }, [language]);

  useEffect(() => {
    if (hash) {
      const frame = requestAnimationFrame(() => {
        document
          .getElementById(hash.slice(1))
          ?.scrollIntoView({ block: "start" });
      });
      return () => cancelAnimationFrame(frame);
    }
    if (mobileRef.current || siteRef.current) {
      scrollToTop(mobileRef.current || siteRef.current);
    }
  }, [pathname, hash, key]);

  useEffect(() => {
    dispatch(getRole());
    dispatch(getToken());
    dispatch(getUserId());
    dispatch(getUsername());
    dispatch(getLanguage());
    dispatch(closeFullLoading());
  }, [token]);

  return (
    <main>
      {isDesktopLayout ? (
        <article
          id="site-frame"
          className={`frame ${isProductRoute ? "product-detail-frame" : ""}`}
          ref={siteRef}
        >
          <Preloader />
          {!isPurchaseRoute && !isFooterRoute && <Header />}
          <section className={`content-container ${className ?? ""}`}>
            {props.children}
          </section>
          {!isPurchaseRoute && <Footer hideAddress={pathname.replace(/\/+$/, "") === "/about-us"} />}
          {isOpenLoginModal && <LoginModal />}
          {isOpenGalleryModal && <GalleryModal />}
          {isOpenReportModal && <ReportModal />}
          {isOpenFullSizeGallery && <FullSizeGallery />}
        </article>
      ) : width > 450 ? (
        <article id="mobile-frame" className="relative">
          <article className="mobile-container" ref={mobileRef}>
            <Preloader />
            {!isPurchaseRoute && !isFooterRoute && <Header />}
            {/* {width > 991 && <SideBar />} */}
            <section className={`content-container ${className ?? ""}`}>
              {props.children}
            </section>
            {!isPurchaseRoute && <Footer hideAddress={pathname.replace(/\/+$/, "") === "/about-us"} />}
            {!isPurchaseRoute && <BottomNavBar />}
            {isOpenLoginModal && <LoginModal />}
            {/* {isOpenProductModal && <ProductModal />} */}
            {isOpenGalleryModal && <GalleryModal />}
            {isOpenReportModal && <ReportModal />}
            {isOpenFullSizeGallery && <FullSizeGallery />}
            {/* {isOpenFullLoading && <CommonLoading />} */}
          </article>
        </article>
      ) : (
        <article id="mobile-frame" className="relative w-100">
          <article className="real-mobile-container" ref={mobileRef}>
            <Preloader />
            {!isPurchaseRoute && !isFooterRoute && <Header />}
            {/* {width > 991 && <SideBar />} */}
            <section className={`content-container ${className ?? ""}`}>
              {props.children}
            </section>
            {!isPurchaseRoute && <Footer hideAddress={pathname.replace(/\/+$/, "") === "/about-us"} />}
            {!isPurchaseRoute && <BottomNavBar />}
            {isOpenLoginModal && <LoginModal />}
            {/* {isOpenProductModal && <ProductModal />} */}
            {isOpenGalleryModal && <GalleryModal />}
            {isOpenReportModal && <ReportModal />}
            {isOpenFullSizeGallery && <FullSizeGallery />}
            {/* {isOpenFullLoading && <CommonLoading />} */}
          </article>
        </article>
      )}
    </main>
  );
}
